export function isPasswordRecoveryPath(url: string): boolean {
  return /^\/(forgot-password|reset-password)\/?$/.test(url.split(/[?#]/)[0]);
}

/** Matches the backend SecurePassword validator used for account registration. */
export function isRecoveryPasswordValid(password: string): boolean {
  return (
    password.length > 8 &&
    password.length < 30 &&
    password.toLowerCase() !== password &&
    /[0-9]/.test(password) &&
    /[.,\-_*+!?()=]/.test(password)
  );
}
